// extracted by mini-css-extract-plugin
export default {"container":"WelcomeButton_container__JvfQm"};